var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-cta',{attrs:{"title":`${_vm.pre}.title`,"description":`${_vm.pre}.description`,"cta":`${_vm.pre}.cta`},on:{"click":function($event){return _vm.$emit('click:cta')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }